module.exports = __webpack_public_path__ + "img/marker2.c79eb8c2.png";